import { useRecordContext } from "react-admin";

export const GameTitle = ({ prefix }: { prefix?: string }) => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return null;
    return <span>{prefix ? `${prefix} `: ''}Game: {record.name}</span>;
};